var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9321 3.99238C18.5096 4.56979 18.519 5.50299 17.9534 6.09198L10.8203 13.5203C10.545 13.807 10.1672 13.9727 9.76984 13.9811L6.77055 14.044L6.83379 11.0295C6.84194 10.6411 7.00041 10.2711 7.27585 9.99722L14.5696 2.74511C15.1559 2.16218 16.1033 2.16354 16.6879 2.74814L17.9321 3.99238Z",
    fill: "#3699FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.7513 1.66602C11.2115 1.66602 11.5846 2.03911 11.5846 2.49935C11.5846 2.95959 11.2115 3.33268 10.7513 3.33268H5.0013C4.08083 3.33268 3.33464 4.07887 3.33464 4.99935V14.9993C3.33464 15.9198 4.08083 16.666 5.0013 16.666H15.0013C15.9218 16.666 16.668 15.9198 16.668 14.9993V10.8327C16.668 10.3724 17.0411 9.99935 17.5013 9.99935C17.9615 9.99935 18.3346 10.3724 18.3346 10.8327V14.9993C18.3346 16.8403 16.8423 18.3327 15.0013 18.3327H5.0013C3.16035 18.3327 1.66797 16.8403 1.66797 14.9993V4.99935C1.66797 3.1584 3.16035 1.66602 5.0013 1.66602H10.7513Z",
    fill: "#3699FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/Write.f8616f64.svg";
export { ForwardRef as ReactComponent };